/** BookingsTab — one tab button in {@link BookingsTabs} (BON-490). Active tab
 *  underlines in primary; the count badge matches. `id`/`aria-controls` pair
 *  with the tabpanel `id`/`aria-labelledby` in BookingsTabBody; `tabIndex`
 *  implements the roving-tabindex pattern (only the active tab is in the Tab
 *  order — arrow keys move focus within the tablist, wired in BookingsTabs). */
import type { TabId } from './bookingsCardTypes';

export function BookingsTab({
  id,
  label,
  count,
  active,
  onClick,
}: {
  id: TabId;
  label: string;
  count: number;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="nb-booking-tab"
      id={`tab-${id}`}
      role="tab"
      aria-selected={active}
      aria-controls={`panel-${id}`}
      tabIndex={active ? 0 : -1}
      data-tab-id={id}
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        height: 30,
        padding: '0 10px',
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        borderBottom: `2px solid ${active ? 'var(--nb-primary)' : 'transparent'}`,
        marginBottom: -1,
        fontSize: 12,
        fontWeight: 700,
        color: active ? 'var(--nb-ink)' : 'var(--nb-subtle)',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
      <span
        className="nb-tabular"
        style={{
          minWidth: 17,
          height: 17,
          padding: '0 5px',
          borderRadius: 999,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 10,
          fontWeight: 700,
          background: active ? 'var(--nb-primary-soft)' : 'var(--nb-surface-2)',
          color: active ? 'var(--nb-primary)' : 'var(--nb-subtle)',
        }}
      >
        {count}
      </span>
    </button>
  );
}
